import {Typed} from "app/stimulus/typed-stimulus";
import {Controller} from "@hotwired/stimulus";

export default class extends Typed(Controller<HTMLElement>, {
    values: {
        ibanCountries: Array<string>,
        isSetupLayoutLocked: {type: Boolean, default: false},
    },
    targets: {
        bankCountry: HTMLInputElement,
        currency: HTMLInputElement,
        iban: HTMLInputElement,
        ibanContainer: HTMLElement,
        accountNumber: HTMLInputElement,
        accountNumberContainer: HTMLElement,
        bankName: HTMLInputElement,
        bankNameContainer: HTMLElement,
        bankInfoContainer: HTMLElement,
        bankInfo: HTMLInputElement,
        isMultiCurrency: HTMLInputElement,
    }
})
{
    public connect(): void {
        this.setupLayout();
    }

    public onBankCountryValueChange(): void {
        this.setupLayout();
    }

    public onCurrencyValueChange(): void {
        this.setupLayout();
    }

    public onIsMultiCurrencyChange(): void {
        this.setupLayout();
    }

    private setupLayout(): void {
        if (this.isSetupLayoutLockedValue) {
            return;
        }
        this.isSetupLayoutLockedValue = true;
        try {
            if (this.hasIsMultiCurrencyTarget && this.isMultiCurrencyTarget.checked) {
                if (this.hasBankCountryTarget) {
                    this.bankCountryTarget.value = 'CZ';
                    this.bankCountryTarget.dispatchEvent(new Event('change', {bubbles: true}));
                    this.bankCountryTarget.setAttribute('disabled', 'disabled');
                }
                if (this.hasCurrencyTarget) {
                    this.currencyTarget.value = '';
                    this.currencyTarget.dispatchEvent(new Event('change', {bubbles: true}));
                    this.currencyTarget.setAttribute('disabled', 'disabled');
                }
                this.showIban();
                this.hideAccountNumber();
                this.hideBankInfo();
                this.hideBankName();
                return;
            }
            if (this.hasBankCountryTarget) {
                this.bankCountryTarget.removeAttribute('disabled');
            }
            if (this.hasCurrencyTarget) {
                this.currencyTarget.removeAttribute('disabled');
            }
            const country = this.hasBankCountryTarget ? this.bankCountryTarget.value : '';
            const currency = this.hasCurrencyTarget ? this.currencyTarget.value : '';
            if ((country === 'CZ' && currency === 'CZK') || (this.hasIbanCountriesValue && this.ibanCountriesValue.indexOf(country) < 0)) {
                this.showAccountNumber();
                this.hideIban();
            } else {
                this.hideAccountNumber();
                this.showIban();
            }
            if (country === 'CZ') {
                this.hideBankInfo();
                this.hideBankName();
            } else {
                this.showBankInfo();
                this.showBankName();
            }
        } finally {
            this.isSetupLayoutLockedValue = false;
        }
    }


    private hideBankInfo(): void {
        if (this.hasBankInfoTarget) {
            this.bankInfoTarget.value = '';
            this.bankInfoTarget.dispatchEvent(new Event('change', {bubbles: true}));
            this.bankInfoTarget.setAttribute('disabled', 'disabled');
        }
        if (this.bankInfoContainerTarget) {
            this.bankInfoContainerTarget.style.display = 'none';
        }
    }

    private showBankInfo(): void {
        if (this.hasBankInfoTarget) {
            this.bankInfoTarget.removeAttribute('disabled');
        }
        if (this.bankInfoContainerTarget) {
            this.bankInfoContainerTarget.style.display = '';
        }
    }

    private hideBankName(): void {
        if (this.hasBankNameTarget) {
            this.bankNameTarget.value = '';
            this.bankNameTarget.dispatchEvent(new Event('change', {bubbles: true}));
            this.bankNameTarget.setAttribute('disabled', 'disabled');
        }
        if (this.bankNameContainerTarget) {
            this.bankNameContainerTarget.style.display = 'none';
        }
    }

    private showBankName(): void {
        if (this.hasBankNameTarget) {
            this.bankNameTarget.removeAttribute('disabled');
        }
        if (this.bankNameContainerTarget) {
            this.bankNameContainerTarget.style.display = '';
        }
    }

    private hideIban(): void {
        if (this.hasIbanTarget) {
            this.ibanTarget.value = '';
            this.ibanTarget.dispatchEvent(new Event('change', {bubbles: true}));
            this.ibanTarget.setAttribute('disabled', 'disabled');
        }
        if (this.hasIbanContainerTarget) {
            this.ibanContainerTarget.style.display = 'none';
        }
    }

    private showIban(): void {
        if (this.hasIbanTarget) {
            this.ibanTarget.removeAttribute('disabled');
        }
        if (this.hasIbanContainerTarget) {
            this.ibanContainerTarget.style.display = '';
        }
    }

    private hideAccountNumber(): void {
        if (this.hasAccountNumberTarget) {
            this.accountNumberTarget.value = '';
            this.accountNumberTarget.dispatchEvent(new Event('change', {bubbles: true}));
            this.accountNumberTarget.setAttribute('disabled', 'disabled');
        }
        if (this.hasAccountNumberContainerTarget) {
            this.accountNumberContainerTarget.style.display = 'none';
        }
    }

    private showAccountNumber(): void {
        if (this.hasAccountNumberTarget) {
            this.accountNumberTarget.removeAttribute('disabled');
        }
        if (this.hasAccountNumberContainerTarget) {
            this.accountNumberContainerTarget.style.display = '';
        }
    }
}
